import React, { useState, useEffect } from "react";
import { Button, Slider, ProgressBar, HTMLSelect, Classes, Tooltip } from "@blueprintjs/core";

export function AudioControl(props) {
  const [volume, setVolume] = useState(10);
  const [muted, mute] = useState(false);
  const [micro, setMicro] = useState(true);
  const [volumemicro, setVolumeMicro] = useState(0);
  const [inputs, setInputs] = useState([]);
  const [outputs, setOutputs] = useState([]);



  useEffect(() => {
    const list = Promise.resolve(navigator.mediaDevices.enumerateDevices());
    list.then((val => {
      setInputs(val.filter((media) => media.kind === "audioinput").map(media => { return { value: media.deviceId, label: media.label } }));
      setOutputs(val.filter((media) => media.kind === "audiooutput").map(media => { return { value: media.deviceId, label: media.label } }));
    }));


    navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    })
      .then(function (stream) {
        new MediaRecorder(stream);
        const audioContext = new AudioContext();
        const analyser = audioContext.createAnalyser();
        const microphone = audioContext.createMediaStreamSource(stream);
        const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

        analyser.smoothingTimeConstant = 0.1;
        analyser.fftSize = 1024;

        microphone.connect(analyser);
        analyser.connect(scriptProcessor);
        scriptProcessor.connect(audioContext.destination);
        scriptProcessor.onaudioprocess = function () {
          const array = new Uint8Array(analyser.frequencyBinCount);
          analyser.getByteFrequencyData(array);
          const arraySum = array.reduce((a, value) => a + value, 0);
          const average = (arraySum / array.length) / 50;
          // colorPids(average);
          setVolumeMicro(average);
        };
      })
      .catch(function (err) {
        console.error("GetMicro", err);
      });
  }, []);


  return <Tooltip
    interactionKind="click"
    content={
      <table>
        <tbody >
          <tr>
            <td>
              <Button
                icon={muted ? "volume-off" : "volume-up"}
                onClick={() => {
                  if (muted)
                    props.onVolumeChange(volume / 10)
                  else
                    props.onVolumeChange(0)
                  mute(!muted)
                }}
              />
            </td>
            <td className={Classes.DRAWER_FOOTER}>
              {/* sound level/mute */}
              <Slider
                min={0}
                max={10}
                stepSize={0.1}
                value={volume}
                labelValues={[]}
                labelRenderer={false}
                disabled={muted}
                onChange={(new_volume) => {
                  setVolume(new_volume);
                  props.onVolumeChange(new_volume / 10)
                }}
              />
            </td>
            <td>
              <HTMLSelect
                options={outputs}
                onChange={(media) => props.onOutputChange(media.target.value)}>
              </HTMLSelect>
            </td>
          </tr>
          <tr>
            <td>
              <Button
                icon={micro ? microIcon : "cross"}
                onClick={() => {
                  props.pull_data(micro)
                  setMicro(!micro)
                }}
              />
            </td>
            <td className={Classes.DRAWER_FOOTER}>
              {/* micro */}
              <ProgressBar
                animate={false}
                intent={"primary"}
                stripes={false}
                value={micro ? volumemicro : 0}
              />
            </td>
            <td>
              <HTMLSelect
                options={inputs}
                onChange={(media) => props.onInputChange(media.target.value)}>
              </HTMLSelect>
            </td>
          </tr>
        </tbody></ table>
    }>
    <Button
      icon="cog"
    />
  </Tooltip>
}


const ptIconWrapper = (path, viewboxDefault = 24) => {
  return (
    <span className="bp3-icon">
      <svg
        className="pt-icon"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="16px"
        height="16px"
        viewBox={`0 0 ${viewboxDefault} ${viewboxDefault}`}
      >
        {path}
      </svg>
    </span>
  );
};

const microIcon = ptIconWrapper(
  <path
    d="M16 11c0 2.209-1.791 4-4 4s-4-1.791-4-4v-7c0-2.209 1.791-4 4-4s4 1.791 4 4v7zm4-2v2c0 4.418-3.582 8-8 8s-8-3.582-8-8v-2h2v2c0 3.309 2.691 6 6 6s6-2.691 6-6v-2h2zm-7 13v-2h-2v2h-4v2h10v-2h-4z"
  />,
  24
); 